import { RouteObject } from 'react-router';

import { PatientsPageLazy } from './page.tsx';

import { RoleProtectedRoute } from '@/services/roles';
import { EAdminRoutes } from '@/services/router/enums';

export const PATIENTS_ROUTE: RouteObject = {
    path: EAdminRoutes.Patients,
    element: (
        <RoleProtectedRoute path={EAdminRoutes.Patients}>
            <PatientsPageLazy />
        </RoleProtectedRoute>
    ),
};
